import { render } from "./AssignLab.vue?vue&type=template&id=185d639a&scoped=true"
import script from "./AssignLab.vue?vue&type=script&lang=js"
export * from "./AssignLab.vue?vue&type=script&lang=js"

import "./AssignLab.vue?vue&type=style&index=0&id=185d639a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-185d639a"

export default script